import SampleTrendsView from '@/components/SampleTrendsView';

export default function EffluentTrendsPage() {
  return (
    <SampleTrendsView
      sampleType="effluent"
      title="Effluent Sample Trends"
      subtitle="Select effluent samples (including DAF effluent) to view compliance trends and generate regulatory reports"
    />
  );
}
